import axios from 'axios';
import { OpenProjectMapped } from '../../../../types';
import { API_URL } from '../../../../utils/config';

export const getMapOpenProjects = (): Promise<OpenProjectMapped[]> =>
  axios.get(`${API_URL}/open_project/map/`).then((r) => r.data);
